import React, { useState, Fragment, Component } from "react";
import Shimmer from "react-shimmer-effect";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
} from "reactstrap";
import { Link, useHistory, useParams, Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import { Preview } from "../../../../helpers/ui/FileInput";
import apiResponse from "../../../../services/apiResponse";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import { ConfirmAlert } from "../../../../helpers/ui/alert";

import DetailBloc from "./Blocs/DetailBloc";
import Select from "react-select";

var reformatType = function (regions) {
  return regions.map(function (region) {
    var newObj = {};
    newObj["label"] = region.name;
    newObj["value"] = region.status;
    return newObj;
  });
};

const reformatDate = (date) => {
  const months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];
  const d = new Date(date);
  let dt = d.getDate();
  if (dt < 10) dt = "0" + dt;

  return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
};

class IndexView extends Component {
  detailBloc = new DetailBloc();

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {
        uuid: "",
        periode: "",
        keterangan: "",
      },
      typeItems: [],
      typeSelected: "",
    };
  }

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
      },
      confirm: true,
    });
  };

  onChangeTypeSelected = (type) => {
    this.setState({
      typeSelected: type.value,
    });
  };

  submitData = async () => {
    await this.detailBloc.fetchSubmit(this.state.dataForm);
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.detailBloc.submitChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.detailBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              detail: response,
              dataForm: {
                uuid: response.emp_retired_submission_uuid,
                periode:
                  reformatDate(response.emp_retired_submission_date_start) +
                  " - " +
                  reformatDate(response.emp_retired_submission_date_end),
                keterangan: response.emp_retired_submission_description,
              },
              typeSelected: response.emp_retired_submission_status,
            });
            console.log(response);
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    const queryParams = new URLSearchParams(this.props.location.search);
    this.detailBloc.fetchDetail({ uuid: queryParams.get("uuid") });

    this.setState({
      typeItems: reformatType([
        {
          name: "Menunggu Proses",
          status: 0,
        },
        {
          name: "Diterima",
          status: 1,
        },
        {
          name: "Ditolak",
          status: 2,
        },
      ]),
      dataForm: {
        uuid: queryParams.get("uuid"),
      },
    });
  }

  componentWillUnmount() {
    this.detailBloc.submitChannel?.unsubscribe();
    this.detailBloc.detailChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card className="">
                <CardBody>
                  <CardTitle>Detail Periode Pemberhentian</CardTitle>
                  <CardSubtitle className="mb-3">
                    Informasi Periode Pemberhentian
                  </CardSubtitle>
                  <hr />

                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <AvField
                      name="uuid"
                      type="hidden"
                      id="uuid"
                      value={this.state.dataForm.uuid}
                    />

                    <Row className="mb-3">
                      <label className="col-md-3">Periode</label>
                      <Col md="9">
                        {this.state.dataForm.periode ? (
                          <>
                            {this.state.dataForm.periode !== ""
                              ? this.state.dataForm.periode
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3">Keterangan</label>
                      <Col md="9">
                        {this.state.dataForm.keterangan ? (
                          <>
                            {this.state.dataForm.keterangan !== ""
                              ? this.state.dataForm.keterangan
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3">
                        Pilih Status <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <Select
                          value={this.state.typeItems.filter(
                            (option) => option.value === this.state.typeSelected
                          )}
                          onChange={this.onChangeTypeSelected}
                          required="required"
                          options={this.state.typeItems}
                          classNamePrefix=""
                          placeholder="Pilih Status"
                        />
                        <AvField
                          name="status_approval"
                          type="hidden"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="status_approval"
                          value={this.state.typeSelected}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to={`pensiun.html`}>
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin ?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil diverifikasi"
          failedTitle="Gagal!"
          failedInfo="Data gagal diverifikasi"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to={`/kepegawaian/pensiun.html`} />
        ) : null}
      </Fragment>
    );
  }
}

//export default IndexView
export default withRouter(IndexView);
